import { useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PlaceholderContext } from "../../contexts/Contexts";
import { Dialog } from "../modal/Dialog";
import CodeErrorTemplate from "../../templates/CodeErrorTemplate";
import CollectionList from "../../widgets/CollectionList";
import TagsList from "./TagsList";
import { ReloadSvg, BoxArrowOutSvg, BoxArrowInSvg, ListCheckSvg, ListMinusSvg, DeleteSvg } from "../../icons/Icon";
import TagDiscountInputBar from "./TagDiscountInputBar";
import {
    selectAllVariantsEvent,
    selectNoneVariantsEvent,
} from "../../events/VariantEditorEvents";
import { fetchAllVariantsEvent } from "../../events/VariantEvents";
import { fetchAllDiscountsEvent } from "../../events/DiscountEvents";
import {
    applyDiscountsToSelectedVariantsEvent,
    deleteDiscountsFromSelectedVariantsEvent,
    deleteAllDiscountsFromSelectedVariantsEvent
} from "../../events/VariantDiscountsEditorEvents";
import { dispatch_FetchAllTagsEvent } from "../../events/TagEvents";
import {
    dispatch_EnableTagDiscountBatchEditEvent,
    dispatch_DisableTagDiscountBatchEditEvent
} from "../../events/TagDiscountEditorEvents";
import {
    dispatch_deleteDiscountsFromTagsEvent,
    dispatch_insertDiscountsToTagsEvent,
    dispatch_selectAllTagsEvent,
    dispatch_deselectAllTagsEvent,
    dispatch_deleteAllDiscountsFromSelectedTagsEvent
} from "../../events/DiscountEvents";

const CustomActions = (p) => {

    const onCheckAll = () => {
        dispatch_selectAllTagsEvent({ list: p.listRef });
    };
    const onUncheckAll = () => {
        dispatch_deselectAllTagsEvent({ list: p.listRef });
    };
    const onApplyToSelected = () => {
        dispatch_insertDiscountsToTagsEvent({ list: p.listRef, input: p.inputRef });
    }
    const onRemoveFromSelected = () => {
        dispatch_deleteDiscountsFromTagsEvent({ list: p.listRef, input: p.inputRef })
    }
    const onClearAllSelected = () => {
        dispatch_deleteAllDiscountsFromSelectedTagsEvent({ list: p.listRef });
    }
    const onReload = () => {
        dispatch_FetchAllTagsEvent(true);
    };

    return (
        <div className="CollectionList_actions">
            <button className="CollectionList_reload" onClick={onReload}><ReloadSvg /></button>
            <button className="CollectionList_ApplyToAll" onClick={onApplyToSelected}><BoxArrowInSvg /></button>
            <button className="CollectionList_RemoveFromAll" onClick={onRemoveFromSelected}><BoxArrowOutSvg /></button>
            <button className="CollectionList_RemoveFromAll" onClick={onClearAllSelected}><DeleteSvg /></button>
            <button className="CollectionList_CheckAll" onClick={onCheckAll}><ListCheckSvg /></button>
            <button className="CollectionList_UncheckAll" onClick={onUncheckAll}><ListMinusSvg /></button>
        </div >
    );
}
const TagDiscountEditor = (p) => {

    const list = useRef(null);
    const inputBar = useRef(null);
    const tags = useSelector((state) => state.base.tags);

    useEffect(() => {
        dispatch_FetchAllTagsEvent();
        fetchAllVariantsEvent();
        fetchAllDiscountsEvent();
    }, []);


    const onMultiSelected = (s) => {
        if ((Object.keys(s).length > 1)) {
            dispatch_EnableTagDiscountBatchEditEvent();
        } else {
            dispatch_DisableTagDiscountBatchEditEvent();
        }
    };

    return (
        <>
            <div className="page">
                <div className="flex-24">
                    <div className="col-24 flex-column">
                        <div className="page-box">
                            <div className='page-box-header'>
                                <h4><span>Discounts to tags editor</span></h4>
                            </div>
                            <div className='page-box-body'>
                                <TagDiscountInputBar ref={inputBar} />
                                <CollectionList
                                    ref={list}

                                    selectable={true}
                                    selectAll={true}
                                    unSelectAll={false}
                                    onSelect={onMultiSelected}
                                    itemsPerPage={10}
                                    items={tags}

                                    ItemsComponent={TagsList}

                                    CustomActionsComponent={(p) => <CustomActions listRef={list} inputRef={inputBar} />}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TagDiscountEditor;